<template>
  <article class="auction-order">
    <p class="like-count" v-if="info.num_dealer_interested">
      {{ info.num_dealer_interested }}人想要
    </p>

    <group class="auction-manage fn-red" :title="carStatus">
      <cell :title="info.car_model_name" :bdStart="true" class="v-primary-lh">
        <div slot="after-title" class="vux-label-desc mt fc-blue"
            @click.stop="toCarInformation">完整车况&nbsp;&gt;</div>
        <div class="service-icon" slot="icon">
          <img :src="info.car_image_url">
        </div>
      </cell>

      <div class="button-auction-inquiry">
        <div class="button-auction-info" @click="toAuctionInquiry('/auction/manage', info.auction_car_id)">
          <i class="icon icon-auction" />
          <span class="text">拍卖信息</span>
        </div>
        <div v-if="seeEnquiryAuth" class="button-inquiry-info" @click="toAuctionInquiry('/inquiry/inquiryList/inquirys', info.auction_car_id)">
          <i class="icon icon-inquiry" />
          <span class="text">询价信息</span>
        </div>
      </div>

      <cell class="no-top-border">
        <div slot="after-title">
          <flexbox class="flexbox" v-for="(item, index) in carInfo" :key="index">
            <flexbox-item :span="180/690" class="key">{{item.title}}</flexbox-item>
            <flexbox-item class="value">{{{ key: item.key, val: info[item.key] } | formatValue}}
            </flexbox-item>
          </flexbox>
        </div>
      </cell>
      <cell>
        <div slot="after-title">
          <flexbox class="flexbox" v-for="(item, index) in priceList" :key="index">
            <flexbox-item :span="180/690" class="key">{{item.title}}</flexbox-item>
            <flexbox-item class="value">
              {{info[item.key] | formatPrice}}
            </flexbox-item>
          </flexbox>
        </div>
      </cell>
    </group>
    <outbound-config :type="saleType" :info="saleInfo" @click-swiper="clickSwiper"></outbound-config>
    <images-previewer :list="images" ref="previewer" :options="options" :w='600' :h='400'></images-previewer>
  </article>
</template>
<script>
import { Cell, Group, Flexbox, FlexboxItem } from '@lx-frontend/cvux'
import OutboundConfig from '../outBound/components/OutboundConfig'
import ImagesPreviewer from '@lx-frontend/images-previewer'
const carInfo = [{
  key: 'auction_car_id',
  title: '车辆编号'
}, {
  key: 'vin',
  title: '车架号'
}, {
  key: 'plate_number',
  title: '车牌号'
}, {
  key: 'license_issued_on',
  title: '新车交车'
}, {
  key: 'mileage',
  title: '行驶里程'
}, {
  key: 'car_color',
  title: '车身颜色'
}, {
  key: 'transfer_count',
  title: '过户次数'
}, {
  key: 'belonged_province',
  title: '车辆归属地'
}, {
  key: 'channel',
  title: '线索来源'
}]
export default {
  components: { Cell, Group, Flexbox, FlexboxItem, OutboundConfig, ImagesPreviewer },
  data() {
    return {
      options: {
        getThumbBoundsFn (index) {
          let isServer = typeof window === 'undefined'
          if (isServer) return
          // find thumbnail element
          let thumbnail = document.querySelectorAll('.item_img')[index]
          // get window scroll Y
          let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
          // optionally get horizontal scroll
          // get position of element relative to viewport
          let rect = thumbnail.getBoundingClientRect()
          // w = width
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
          // Good guide on how to get element coordinates:
          // http://javascript.info/tutorial/coordinates
        }
      },
      carStatus: '',
      saleType: '',
      saleInfo: {},
      carInfo: carInfo,
      priceList: [{ // 价格列表
        key: 'contract_price',
        title: '收车实价'
      }, {
        key: 'maximum_price',
        title: '最高报价'
      }, {
        key: 'winning_price',
        title: '中标金额'
      }, {
        key: 'actual_paid_amount',
        title: '实收金额'
      }, {
        key: 'maximum_quote_price',
        title: '最高拍卖出价'
      }, {
        key: 'match_price',
        title: '撮合价格'
      }, {
        key: 'actual_match_price',
        title: '实收金额'
      }],
      specialPrice: ['maximum_price', 'winning_price', 'maximum_quote_price'],
      carInfoId: '',
      auctionId: '', // 查看报价信息
      enquiryId: '', // 查看询价信息
      info: {},
      images: [],
      seeEnquiryAuth: false // 查看询价信息权限
    }
  },
  created() {
    let carId = this.$route.params.id
    if (carId) {
      this.$rest.auction.getVehicleCarDetail(null, carId).then((res) => {
        if (res.code === 0) {
          let data = res.data
          let status = data.status
          let days = `（${data.days_in_stock}天）`
          switch (status) {
            case 1: // 库存
              this.priceList.splice(3)
              this.carStatus = data.enquiring ? `库存（询价中）${days}天` : `库存${days}`
              break
            case 2: // 拍卖中
              this.priceList.splice(3)
              this.carStatus = `库存（拍卖中）${days}`
              break
            case 3: // 拍卖已出库
              this.priceList.splice(4)
              this.carStatus = `已出库（拍卖）${days}`
              break
            case 9: // 撮合中
            case 4:
              this.priceList.splice(2, 3).pop()
              this.carStatus = `库存（撮合中）${days}`
              break
            case 5: // 流拍撮合已出库
              this.priceList.splice(2, 2)
              this.carStatus = `已出库（流拍撮合）${days}`
              break
            case 10: // 询价撮合已出库
              this.priceList.splice(2, 2)
              this.carStatus = `已出库（询价撮合）${days}`
              break
            case 6: // 报废出库
              this.priceList.splice(4)
              this.saleType = 'scrap'
              this.saleInfo = data.scrap
              this.carStatus = `已出库（报废）${days}`
              break
            case 7: // 零售出库
              this.priceList.splice(4)
              this.saleType = 'retail'
              this.saleInfo = data.retail
              this.carStatus = `已出库（零售）${days}`
              break
            case 8: // 批售出库
              this.priceList.splice(4)
              this.saleType = 'batch_sale'
              this.saleInfo = data.batch_sale
              this.carStatus = `已出库（批售）${days}`
              break
            case 11: // 特殊出库
              this.priceList.splice(4)
              this.saleType = 'special'
              this.saleInfo = data.special
              this.carStatus = `已出库（特殊出库）${days}`
              break
            case 12: // 出库审核中
              this.priceList.splice(3)
              this.carStatus = `库存（出库审核中）${days}`
              break
            default:
              this.carStatus = '未知'
              break
          }
          this.info = data
          this.carInfoId = data.auction_car_info_id
          this.enquiryId = data.enquiry_id
          this.auctionId = data.auction_id
          if (data[this.saleType] && data[this.saleType].images) {
            this.images = data[this.saleType].images
            if (this.images.length > 0) {
              this.images = this.render(this.images)
            }
          }
        } else {
          this.showToast(res.message)
        }
      })
    }
    // 查看询价信息权限
    this.$store.state.promiseAuth.then(auth => {
      this.seeEnquiryAuth = auth.authList.includes('used_car_car.enquiry.view')
    })
  },
  filters: {
    formatValue({ key, val }) {
      if (key === 'channel') {
        let channelList = [ // 渠道
          { key: 1, value: '销售端潜客' },
          { key: 2, value: '外部采购' },
          { key: 3, value: '其他' },
          { key: 4, value: '公务车处置' },
          { key: 5, value: '寄售' },
          { key: 6, value: '售后端保客' }
        ]
        let item = channelList.find(v => v.key === val)
        return item ? item.value : '--'
      } else if (key === 'transfer_count') {
        return `${val}次`
      } else {
        return val
      }
    },
    formatPrice(val) {
      return val ? `${(val / 100).toFixed(2)}元` : '--'
    }
  },
  methods: {
    clickSwiper(item) {
      this.$refs.previewer.show(item)
    },
    render(arr = []) {
      arr.map((v, i) => {
        let img = new window.Image()
        img.src = v.src
        // 如果图片被缓存，则直接返回缓存数据
        if (img.complete) {
          v.w = img.width
          v.h = img.height
          this.imgCount++
        } else {
          // 完全加载完毕的事件
          img.onload = () => {
            v.w = img.width
            v.h = img.height
            this.imgCount++
          }
        }
      })
      return arr
    },
    toAuctionInquiry(path, carId) {
      this.$router.push({
        path: path,
        query: {
          operation: 'search',
          searchType: 'auction_car_id',
          value: carId
        }
      })
    },
    toCarInformation() {
      let needOperate = this.$route.query.needOperate
      if (needOperate) {
        let isSell = this.info.status
        // status| description
        //  1    | 库存（在库）
        //  2    | 拍卖中
        //  3    | 拍卖已出库
        //  4    | 流拍撮合中
        //  5    | 流拍撮合已出库
        //  6    | 报废出库
        //  7    | 零售出库
        //  8    | 批售出库
        //  9    | 询价撮合中
        //  10   | 询价撮合已出库
        //  11   | 特殊出库
        //  12   | 出库审核中
        switch (isSell) {
          case 2:
          case 3:
            this.$router.push({ path: `/auction/info/${this.auctionId}` })
            break
          case 4:
          case 5:
            this.$router.push({ path: `/auction/match/carinfo/${this.info.match_id}`, query: { from: 'auctionMatch' } })
            break
          case 6:
          case 7:
          case 8:
          case 11: // 报废、零售、批售、特殊出库的车辆详情
            this.$router.push({ path: `/auction/outbound/carinfo/${this.info.auction_car_id}`, query: { from: 'outbound' } })
            break
          case 12: // 出库审核中
            this.$router.push({ path: `/auction/outbound/carinfo/${this.info.obrequest_id}?from=outBoundReview` })
            break
          case 9:
          case 10: // 询价撮合车车辆详细。需要带上query: {from: 'enquiryMatch'}
            this.$router.push({ path: `/auction/match/carinfo/${this.info.enquiry_match_id}`, query: { from: 'enquiryMatch' } })
            break
          default:
            this.$rest.auction.getNewCar({
              former_car_info_id: this.carInfoId
            }).then(res => {
              if (res.code === 0) {
                this.$router.push({
                  path: `/auction/carInfo/edit/${res.data.car_info_id}/auction`
                })
              } else {
                this.showToast(res.message)
              }
            })
            break
        }
      } else {
        this.$router.push({
          path: `/usedcar/evaluateReport/${this.carInfoId}/auction`
        })
      }
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
@import "../../stylesheets/modules/manage/order.less";
.auction-order {
  .auction-manage {
    position: relative;
    .weui_cells:after {
      border-bottom: 0;
    }
  }
  .like-count {
    position: absolute;
    top: 34/@w2;
    right: 30/@w2;
    font-size: 26/@w2;
    color: #666;
  }
}
</style>
